import { render } from "./SimulationWorksCard.vue?vue&type=template&id=0e556032&scoped=true&ts=true"
import script from "./SimulationWorksCard.vue?vue&type=script&lang=ts"
export * from "./SimulationWorksCard.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e556032"]])

export default __exports__